/**
 * Chaves transitivas do localStorage vinculadas à persona ativa,
 * carrinho, avaliação e fluxo de checkout.
 */
export const PERSONA_TRANSIENT_KEYS = [
  "shoppingCart",
  "shoppingCoupon",
  "coupon",
  "checkoutKitId",
  "kit",
  "anamneseEvaluationV2",
  "kitFlavorPreference",
  "kitRecorrencia",
  "currentAnamnesis",
  "userAnswers",
  "selectedFormulaIds",
  "selectedShipping",
  "selectedShippingPersonaId",
  "shippingOptions",
  "lastCalculatedZip",
  "cartHash",
  "launchCouponCode",
  "launchCouponPercent",
  "launchForId",
  "launchForIds",
  "launchActive",
  "launchPin",
  "launchPin.email",
  "launchIncludeBasico",
  "anamneseOrigin",
  "pendingCouponCode",
  "evaluationResult",
  "adultEvaluation",
  "kidsEvaluation",
  "babyEvaluation",
  "newAnamnesePerId",
];

/**
 * Remove chaves legadas e duplicadas do localStorage para manter
 * apenas 'selectedProfileId' como fonte única da persona ativa.
 */
export function cleanupLegacyPersonaKeys() {
  try {
    localStorage.removeItem("newAnamnesePerId");
    Object.keys(localStorage)
      .filter(
        (k) =>
          k.startsWith("selectedProfileId:") ||
          k.startsWith("newAnamnesePerId:") ||
          k === "newAnamnesePerId"
      )
      .forEach((k) => localStorage.removeItem(k));
  } catch {}
}

/**
 * Remove todos os resumos de compra temporários (purchase_summary_*) do localStorage.
 */
export function clearPurchaseSummaries() {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("purchase_summary_"))
      .forEach((k) => localStorage.removeItem(k));
  } catch {}
}

/**
 * Limpa todos os dados transitivos de carrinho, anamnese e checkout do localStorage.
 */
export function clearPersonaSessionState() {
  try {
    PERSONA_TRANSIENT_KEYS.forEach((key) => {
      localStorage.removeItem(key);
    });
    cleanupLegacyPersonaKeys();
    clearPurchaseSummaries();
  } catch (e) {
    console.error("Erro ao limpar dados transitivos da persona:", e);
  }
}

/**
 * Troca a persona ativa no localStorage, limpando dados transitivos da persona anterior,
 * mantendo estritamente a chave única 'selectedProfileId', e disparando o evento 'profileChanged'.
 */
export function switchActivePersona(personaId, userId = null) {
  try {
    // 1. Limpa dados da persona anterior (carrinho, avaliação, checkout, etc.) e chaves legadas
    clearPersonaSessionState();

    // 2. Define apenas a chave oficial única 'selectedProfileId'
    if (personaId) {
      const pidStr = String(personaId);
      localStorage.setItem("selectedProfileId", pidStr);
    } else {
      localStorage.removeItem("selectedProfileId");
    }

    // 3. Remove resíduos de chaves legadas (selectedProfileId:usrId, newAnamnesePerId, etc.)
    cleanupLegacyPersonaKeys();

    // 4. Dispara evento customizado para que contextos (como CartContext) e páginas reajam
    window.dispatchEvent(
      new CustomEvent("profileChanged", {
        detail: { profileId: personaId ? Number(personaId) : null, userId },
      })
    );
  } catch (e) {
    console.error("Erro ao trocar persona ativa:", e);
  }
}
